import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=09166d52&"
import script from "./wysiwyg.vue?vue&type=script&lang=js&"
export * from "./wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./wysiwyg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports